import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import helper from "../../components/helper/index"
import AddUpdateEmployee from "./AddUpdateEmployee";
import { MyTaskData } from "../../components/Datas";
import { BsChevronRight, BsPlus, BsPersonBadgeFill, BsPuzzleFill } from "react-icons/bs";

const Invited = ({ data, action }) => {
  const [perPage, setPerPage] = useState(250);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

  const openAddUpdateModel = () => {
    setShowAddUpdateModal(true);
    // setAction(null);
    // setUpdateModalData(null);
  };
  const onCloseAddUpdateModal = () => {
    setShowAddUpdateModal(false);
    // setAction(null);
    // setUpdateModalData(null);
  };

  const dataRaw = [
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
  ];

  return (
    <>
      {dataRaw.map((item, index) => (
        <>
          <div className="bg-gray-100 rounded-lg p-3">
            <Link className="flex items-center justify-between ">
              <div className="flex items-center">
                <BsPersonBadgeFill className="items-center text-teal-500" size={18} />
                <div className="ml-4">
                  <p className="text-gray-500 font-bold">Waseem Qasim</p>
                  <p className="text-gray-500">wqasimg@mail.com</p>
                  <p className="text-gray-500 text-sm">Role: Admin</p>
                </div>
              </div>
              <div className="flex items-center">
                <Button color="link" className="text-teal-500 p-0">
                  <BsChevronRight size={24} />
                </Button>
              </div>
            </Link>
          </div>
        </>
      ))}

      {/* <span>Create a new invoice for this case</span> */}
      <div className="flex justify-center mt-3">
        <Button
          color="primary"
          onClick={openAddUpdateModel}
          className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
        >
          <BsPlus size={20} className="mr-2" />
          Add Employee
        </Button>
      </div>

      <AddUpdateEmployee
        show={showAddUpdateModal}
        onClosed={onCloseAddUpdateModal}
        toggle={(prev) => setShowAddUpdateModal(!prev)}
        // addPenalty={addPenalty}
        // rowData={rowData}
        // options={penaltyOptions}
        // loading={overlay}
      />
    </>
  );
};

export default Invited;
